import { render, staticRenderFns } from "./camposConocimiento.vue?vue&type=template&id=c316c944&"
import script from "./camposConocimiento.component.ts?vue&type=script&lang=ts&"
export * from "./camposConocimiento.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports